import axios from 'axios';

const api = axios.create({
  baseURL: 'https://dbmesapp-mesapp.p89nps.easypanel.host/api' /* 'http://localhost:4000/api', */
});
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;
